import { SIDE_COLOR } from "../lib/progress.ts";
import type { Side } from "../lib/session.ts";

/**
 * A side's colour, and a shape of its own with it: a disc for the left, a
 * diamond for the right. The same pair wherever a side shows — the entry,
 * the sets logged, the chart — so the colour never has to be learnt twice,
 * nor read alone.
 */
export function SideMark({ side, size = 10 }: { side: Side; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 10 10" className="shrink-0" aria-hidden>
      {side === "left" ? (
        <circle cx="5" cy="5" r="4" fill={SIDE_COLOR[side]} />
      ) : (
        <rect x="1.75" y="1.75" width="6.5" height="6.5" transform="rotate(45 5 5)" fill={SIDE_COLOR[side]} />
      )}
    </svg>
  );
}
